import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import {PopoverCycleCountDetailsPage} from "./popover-cyclecount-details";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [
    PopoverCycleCountDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(PopoverCycleCountDetailsPage),
    TranslateModule.forChild()
  ],
})
export class PopoverCyclecountDetailsModule {}



// WEBPACK FOOTER //
// ./src/pages/popover-cyclecount-details/popover-cyclecount-details.module.ts